module.exports = __webpack_public_path__ + "static/media/hero.2a038c1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/dukes-park-renovation/hero.jpg
// module id = 56
// module chunks = 0